import { render, staticRenderFns } from "./TreeRow.vue?vue&type=template&id=63f2a23e&scoped=true&"
import script from "./TreeRow.vue?vue&type=script&lang=js&"
export * from "./TreeRow.vue?vue&type=script&lang=js&"
import style0 from "./TreeRow.vue?vue&type=style&index=0&id=63f2a23e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2a23e",
  null
  
)

export default component.exports